import PropTypes from 'prop-types';
import React, { useEffect, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getPartnerOldLocation } from '../../utils/fluxes';
import { useBaseUrl } from '../../utils/useBaseUrl';
import { useProduct } from '../../utils/useProduct';
import Experiment from '../car/experiment';
import Wizard from '../wizard/wizard';
import { saveBaseUrl } from './store/actions';

const partnerNameOldLocation = getPartnerOldLocation();

const Page500Lazy = lazy(() => import('./components/Page500'));
const Page403Lazy = lazy(() => import('./components/Page403'));
const NoResultsLazy = lazy(() => import('../car/noresults'));
const InvalidYearLazy = lazy(() => import('../car/invalidYear'));
const FailedChecklistLazy = lazy(() => import('../person/failedChecklist/FailedChecklist'));
const Page404Lazy = lazy(() => import('./components/Page404'));
const InConstructionLazy = lazy(() => import('./components/InConstruction'));
const CheckoutSuccessComponentSelectorLazy = lazy(() => import('./components/CheckoutSuccess'));

const MainRouter = ({ saveBaseUrl }) => {
  const product = useProduct();
  const baseUrl = useBaseUrl();
  const { t } = useTranslation();

  const experimentPaths = ['/seguro/:product/experiment', '/seguros/:product/experiment'];

  const paths = [
    '/us/partner/:partner/:product/quote',
    '/us/partner/:partner/:product/quote/:flux',
    '/us/partner/:partner/:product/quote/:flux/:step',
    '/mx/partner/:partner/:product/cotizar',
    '/mx/partner/:partner/:product/cotizar/:flux',
    '/mx/partner/:partner/:product/cotizar/:flux/:step',
    '/seguros/:product/cotizar',
    '/seguros/:product/cotizar/:flux',
    '/seguros/:product/cotizar/:flux/:step',
    '/seguro/:product/cotar',
    '/seguro/:product/cotar/:flux',
    '/seguro/:product/cotar/:flux/:step',
    '/partner/:partner/:product/cotizar',
    '/partner/:partner/:product/cotizar/:flux',
    '/partner/:partner/:product/cotizar/:flux/:step',
    '/partner/:partner/:product/cotar',
    '/partner/:partner/:product/cotar/:flux',
    '/partner/:partner/:product/cotar/:flux/:step',
  ];
  const pathToRedirect = [
    '/seguros/:product/cotizar/partners/:partner',
    '/seguro/:product/cotar/partners/:partner',
    '/seguro/:product/quote/partners/:partner',
  ];
  const toRedirect = [
    `/partner/${partnerNameOldLocation}/${t(`products.${product}`)}/${t(`quote`)}${
      window.location.search
    }`,
    `/partner/${partnerNameOldLocation}/${t(`products.${product}`)}/${t(`quote`)}${
      window.location.search
    }`,
    `/partner/${partnerNameOldLocation}/${t(`products.${product}`)}/${t(`quote`)}${
      window.location.search
    }`,
  ];
  useEffect(() => {
    saveBaseUrl(baseUrl);
  }, [baseUrl, saveBaseUrl]);

  return (
    <Switch>
      <Route exact path={`${baseUrl}/error`} component={Page500Lazy} />
      <Route exact path={`${baseUrl}/suspicious-behavior`} component={Page403Lazy} />
      <Route exact path={`${baseUrl}/quotation-noresults`} component={NoResultsLazy} />
      <Route exact path={`${baseUrl}/vehicle-antique-car`} component={InvalidYearLazy} />
      <Route exact path={`${baseUrl}/failed-checklist`} component={FailedChecklistLazy} />
      <Route path={`${baseUrl}/not-found`} component={Page404Lazy} />
      <Route path={`${baseUrl}/en_construccion`} component={InConstructionLazy} />
      <Route path={`${baseUrl}/checkout-thanks`} component={CheckoutSuccessComponentSelectorLazy} />
      <Route
        path={`${baseUrl}/checkout-success`}
        component={CheckoutSuccessComponentSelectorLazy}
      />

      {pathToRedirect.map((path, index) => (
        <Route exact path={path} key={index}>
          <Redirect to={toRedirect[index]} />
        </Route>
      ))}

      <Route exact path={experimentPaths} component={Experiment} />
      <Route exact path={paths} render={(props) => <Wizard {...props} product={product} />} />
      <Route component={Page404Lazy} />
    </Switch>
  );
};

MainRouter.propTypes = {
  saveBaseUrl: PropTypes.func,
};

export default connect(null, { saveBaseUrl })(MainRouter);
